export default __webpack_public_path__ + "finger-of-a-hand-pointing-to-right-direction.png";